export default function PeriodsFixedController(
    $scope,
    $q,
    moment,
    Resources,
    searchUrl,
    UrlFactory,
    Search,
    siteService,
    Scroll,
    BasketFixedUrl,
    WeekOptionsModel
) {
    const defaultWeeks = 4;

    let resources = [];

    let search = {
        start: null,
        weeks: null,
        activityId: null,
        locationId: null,
        isFixed: true, // toggle
    };

    let urlParams = null;

    $scope.searchComplete = false;

    /**
     *  load data using route params
     */
    searchUrl.init().then((res) => {
        urlParams = $scope.urlParams = res;

        search = {
            ...search,
            start: moment(res.date, "DD-MM-YYYY").format("YYYY-MM-DD"),
            weeks: conditionalWeeks(parseInt(res.weeks)),
            activity: res.activity,
            location: res.location,
        };

        $scope.search = search;

        getSearchFixed(
            search.start,
            search.weeks,
            search.activity.CategoryID,
            search.location.ID,
            search.isFixed // true
        ).then(
            (res) => {
                setSeachComplete(res);

                var offset = siteService.headerHeight + 15;

                // $scope.ScrollToResults("main-content-focus", offset);

                Scroll.to("main-content-focus", offset);
            },
            (err) => {
                $scope.searchComplete = true;
                $scope.tableData = null;

                /* // IF NO Periods - run same search but with periods fixed set to false
                if (err == "no-periods") {
                    search.isFixed = false;
                    getSearchFixed(
                        search.start,
                        search.weeks,
                        search.activity.CategoryID,
                        search.location.ID,
                        search.isFixed
                    ).then(
                        (res) => {
                            setSeachComplete(res);
                        },
                        (err) => {
                            // handle exception - do nothing
                        }
                    );
                } */
            }
        );
    });

    const setSeachComplete = (res) => {
        $scope.searchComplete = true;
        $scope.tableData = res;
    };

    $scope.fnSearch = (params) => {
        // Will force route to rerender
        UrlFactory.setRoute(
            urlParams.activity,
            urlParams.location,
            urlParams.date,
            urlParams.start,
            urlParams.end,
            urlParams.hours,
            params.weeks
        );
    };

    $scope.addToBasket = (period) => {
        if (!period.allowBooking) {
            return false;
        }

        BasketFixedUrl.setRoute(
            search.location.ID,
            search.start,
            search.weeks,
            search.activity.CategoryID,
            period.resourceId,
            search.isFixed,
            period.start,
            period.end
        );

        return $q.resolve(period);
    };

    const conditionalWeeks = (weeks) => {
        switch (true) {
            case weeks < WeekOptionsModel[0].weeks: // first (4)
                return defaultWeeks;

            case weeks > WeekOptionsModel[WeekOptionsModel.length - 1].weeks: //last (13)
                return defaultWeeks;

            default:
                return weeks;
        }
    };

    const getSearchFixed = (start, weeks, activityId, locationId, isFixed) => {
        return $q
            .all({
                groupedByWeeks: Search.groupedByWeeks(
                    start,
                    weeks,
                    activityId,
                    locationId,
                    isFixed
                ),
                resources: Resources.getAll(),
            })
            .then(
                (res) => {
                    resources = res.resources;

                    if (!res.groupedByWeeks.length) {
                        return $q.reject("no-periods");
                    }

                    const periodsWithResource = upgradePeriods(
                        res.groupedByWeeks,
                        resources
                    );

                    let preparedTable = prepareTableLayout(
                        periodsWithResource,
                        start,
                        resources
                    );

                    return preparedTable;
                },
                (err) => {}
            );
    };

    const upgradePeriods = (periods, resources) => {
        periods = periods.map((period) => {
            period._resource = Resources.lookupResource(
                period.resourceId,
                resources
            );
            return period;
        });

        return periods;
    };

    const groupByResource = (arr, resources) => {
        let lastKey = "";

        const groupedResources = arr.reduce((acc, period) => {
            if (lastKey !== period._resource.parentId) {
                lastKey = period._resource.parentId;

                acc.push({
                    parentResource: Resources.lookupResource(
                        period._resource.parentId,
                        resources
                    ),
                    resources: new Set(),
                });
            }

            acc[acc.length - 1].resources.add(period._resource);

            return acc;
        }, []);

        return groupedResources.map((resourceGroup) => {
            resourceGroup.resources = Array.from(resourceGroup.resources); // its a Set
            return resourceGroup;
        });
    };

    const createCheckList = (periods) => {
        let facts = new Set();

        periods.map((period) => {
            facts.add(period.resourceId);
        });

        return Array.from(facts);
    };

    const prepareTableLayout = (periods, start, resources) => {
        const checkList = createCheckList(periods);

        let sortedPeriods = sortByTime(
            angular.copy(periods), // upgradePeriods(periods, resources),
            start
        );

        return {
            headers: groupByResource(periods, resources),
            rows: groupByTimeslot(sortedPeriods, start, checkList, resources),
        };
    };

    const groupByTimeslot = (arr, start, checkList, resources) => {
        let lastKey = "";

        return arr
            .reduce((acc, period) => {
                if (lastKey !== period.start) {
                    lastKey = period.start;

                    const startFormat = moment(
                        start + "T" + period.start
                    ).format("HH:mm");

                    const endFormat = moment(start + "T" + period.end).format(
                        "HH:mm"
                    );

                    /**
                     * Create a new row
                     */
                    acc.push({
                        slot: {
                            start: startFormat,
                            end: endFormat,
                        },
                        periods: [],
                        // resources: [],
                        // parentResouce: period._resource.parentId,
                    });
                }

                // period._type = "api";

                acc[acc.length - 1].periods.push(period);

                return acc;
            }, [])
            .map((row) => {
                /**
                 * row : group periods by resource. example (bane indeling)
                 */
                let last = null;
                // console.log("************");
                // console.log(row.periods);
                // console.log(checkList.contructor.name);
                // console.log(row.periods.contructor.name);

                let rowCheckList = angular.copy(checkList); // array

                row.periods.map((period) => {
                    if (rowCheckList.indexOf(period.resourceId) !== -1) {
                        rowCheckList.splice(
                            rowCheckList.indexOf(period.resourceId),
                            1
                        );
                    }
                });

                const missingPeriods = rowCheckList.map((missingResourceId) => {
                    return {
                        resourceId: missingResourceId,
                        availableWeeks: 0,
                        start: row.slot.start,
                        end: row.slot.end,
                        minPrice: 80,
                        allowBooking: false,
                        _type: "dummy-period", // added client side to fill out table with missing periods
                        _resource: Resources.lookupResource(
                            missingResourceId,
                            resources
                        ),
                    };
                });

                const periods = sortById([...row.periods, ...missingPeriods]);

                row.resources = periods.reduce((acc, period) => {
                    if (last !== period._resource.parentId) {
                        last = period._resource.parentId;

                        acc.push({
                            periods: [],
                            parentId: period._resource.parentId,
                        });
                    }

                    acc[acc.length - 1].periods.push(period);

                    return acc;
                }, []);

                return row;
            });
    };

    const sortByTime = (periods, start) => {
        return periods.sort((a, b) => {
            a = moment(start + " " + a.start);
            b = moment(start + " " + b.start);
            return a.diff(b);
        });
    };

    const sortById = (periods, start) => {
        return periods.sort((a, b) => {
            return a.resourceId - b.resourceId;
        });
    };
}
